"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Block = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var icon_1 = require("../../elements/icon/icon");
var icon_type_1 = require("../../elements/icon/icon-type");
var block_style_1 = require("./block-style");
function Block(props) {
    var iconName = props.iconName, title = props.title, children = props.children;
    return ((0, jsx_runtime_1.jsxs)(block_style_1.StyledBlock, { children: [(0, jsx_runtime_1.jsxs)(block_style_1.StyledBlockIconTitle, { children: [(0, jsx_runtime_1.jsx)(icon_1.Icon, { iconName: iconName, size: icon_type_1.IconSize.SMALL }), (0, jsx_runtime_1.jsx)(block_style_1.StyledBlockTitle, { children: title })] }), (0, jsx_runtime_1.jsx)(block_style_1.StyledBlockBody, { children: children })] }));
}
exports.Block = Block;
